import React, { useEffect } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useSelector } from "react-redux";
import userActions from "./actions";
import useStyles from "./Styles";

export default function CustomSidebarAccordion({
  hidden = false,
  group_name,
  accordion_name,
  expanded,
  onChange, 
  children,
}) {
  const classes = useStyles();
  const { updateSidebarAccordions } = userActions();
  const { sidebar_accordions, chart } = useSelector((state) => state.technical_view);

  useEffect(() => {
    if (sidebar_accordions[chart]?.hasOwnProperty(accordion_name)) {
      updateSidebarAccordions(accordion_name);
    }
  }, [sidebar_accordions, chart, accordion_name, updateSidebarAccordions]);

  return (
    <div>
      <Accordion
        square
        expanded={expanded} 
        onChange={() => onChange(accordion_name)} 
        classes={{ root: classes.accordion }}
        className={classes.expanded}
        hidden={hidden}
      >
        <AccordionSummary
          aria-controls={`${group_name}-pulldown`}
          expandIcon={<ExpandMoreIcon />}
          classes={{
            root: classes.accordionSummary,
            expanded: classes.accordionSummaryExpanded,
            content: classes.accordionSummaryContent,
          }}
        >
          <Typography className={classes.groupName}>{group_name}</Typography>
        </AccordionSummary>
        <AccordionDetails
          classes={{
            root: accordion_name === "availability" ? classes.accordionDetailsGauge : classes.accordionDetails,
          }}
        >
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
